/**
 * External tasks v1 (260702) bod 3 — external approve / return-for-fix hook.
 *
 * The current external assignee approves or returns-for-fix; the backend
 * reassigns the task to the internal project PM and records the decision. On
 * success invalidates the external board so the task leaves the external user's
 * filtered view (now assigned to the PM). "rejected" requires a reason
 * (enforced by both the calling UI and the backend).
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitExternalReview } from '../services/api/externalBoard';

export interface UseExternalReviewInput {
  taskId: number;
  decision: 'approved' | 'rejected';
  reason?: string;
  projectId: number;
}

export function useExternalReview() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ taskId, decision, reason }: UseExternalReviewInput) =>
      submitExternalReview(taskId, decision, reason),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({
        queryKey: ['board', String(vars.projectId), 'external'],
      });
    },
  });
}
